import { Observer } from "mobx-react";
import { faCheck } from "@fortawesome/pro-light-svg-icons/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/UI";
import UploadReport from "./UploadReport";

import translationStore from "stores/translation-store";
import { useApp } from "stores/app/context";

import style from "./style";

export default function CompletedWithErrors(props)
{
  const { legacyUpload: upload } = useApp();
  const files = upload.getData("filesCount");

  return (
    <Observer>
    {
      () => (
        <>
          <FontAwesomeIcon icon={faCheck} size={"2x"} color={"rgba(var(--accentColorDark), 1)"} style={{marginBottom: 20}} />
          <div className="title">{translationStore.translate("myalbum.add.complete.title-success")}</div>
          <div className="subtitle">{translationStore.translate("myalbum.add.complete.subtitle-success-with-error", {count: files.failedCount})}</div>
          <UploadReport />
          <Button onClick={() => props.onComplete.current(true)} className="filled" style={{marginTop: "2rem", minWidth: "15rem"}}>{translationStore.translate("base.continue")}</Button>
          <style jsx>{style}</style>
        </>
      )
    }
    </Observer>
  );
}